import { globals } from "@/main";

const toastTypes = ["info", "danger", "warning", "success", "default"];

const Toast = (text = "Undefined message", type = "default") => {
  globals.$vueToast(text, {
    type: toastTypes.includes(type) ? type : "default",
    showIcon: true,
    timeout: 3000,
  });
};

export default Toast;
